/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Advantages_Sample_FormulationInputs */

const en_advantages_sample_formulation = /** @type {(inputs: Advantages_Sample_FormulationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This formulation helps when we move to more complex domains like the`)
};

const es_advantages_sample_formulation = /** @type {(inputs: Advantages_Sample_FormulationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta formulación ayuda cuando nos movemos a dominios más complejos como el`)
};

/**
* | output |
* | --- |
* | "This formulation helps when we move to more complex domains like the" |
*
* @param {Advantages_Sample_FormulationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const advantages_sample_formulation = /** @type {((inputs?: Advantages_Sample_FormulationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Advantages_Sample_FormulationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_advantages_sample_formulation(inputs)
	return en_advantages_sample_formulation(inputs)
});